@if (hasResultData) {
  @for (modelResult of globalSearchResult(); track modelResult.model) {
    @if (modelResult.data.length) {
      <div class="global-search-result-category flex">
        @if (shouldShowSectionTitles) {
          <span class="text-2xl font-semibold text-primary pb-6">
            {{ GLOBAL_SEARCH_MODEL_TO_TITLE_MAPPING[modelResult.model] }}
          </span>
        }
        @for (item of modelResult.data; track item._id; let i = $index) {
          <pfx-global-search-result-item
            [item]="item"
            [isLoading]="isLoading()"
            [isSelected]="selectedIndex() === getFlatResults().indexOf(item)"
          ></pfx-global-search-result-item>
        }
        <p-divider></p-divider>
      </div>
    }
  }
} @else {
  <div class="p-20">
    <span class="text-xl font-semibold text-color">
      {{ 'noResultsFound' | i18next: { ns: GLOBAL_SEARCH_NAMESPACE } }}
    </span>
  </div>
}
